import { Dispatch, bindActionCreators } from "redux";
import { connect } from "react-redux";

import {AppState} from 'diy/redux/app/state';
import {Aviary, AviaryStateProps, AviaryDispatchProps} from './Aviary';
import {closeAviary, saveBackgroundImage as saveBackgroundImageSection} from '../../index';
import {saveBackgroundImage as saveBackgroundImageContainer} from '../../../sectionContainer/index';
import Modul, {ModuleType} from '../../../Modul';

function saveBackgroundImage(imageDataUrl: string) {
    return (dispatch: Dispatch, getState: () => AppState) => {
        let aviaryOptions = getState().moduleSection.aviaryOptions;
        if (Modul.getInstance(aviaryOptions.moduleId).getModuleType() === ModuleType.SECTION) {
            dispatch(saveBackgroundImageSection(imageDataUrl));
        } else {
            dispatch(saveBackgroundImageContainer(imageDataUrl));
        }
    };
}

function mapStateToProps(state: AppState): AviaryStateProps {
    const ownState = state.moduleSection;

    return {
        open: ownState.aviaryOpen,
        options: ownState.aviaryOptions,
    };
};

function mapDispatchToProps(dispatch: Dispatch): AviaryDispatchProps {
    return bindActionCreators<AviaryDispatchProps>({
        onAviaryClose: () => closeAviary({}),
        onAviarySave: saveBackgroundImage
    }, dispatch);
}

export const ConnectedAviary = connect(mapStateToProps, mapDispatchToProps)(Aviary);



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/aviary/ConnectedAviary.tsx
 **/